"use strict";
import ErrorBoundary from "components/ErrorBoundary";
import { RiseIn } from "pages/Landing/components/animations";
import { Suspense, lazy } from "react";
import { Flex, Text } from "ui/src";
const SwapWidgetLazy = lazy(() => import("@deli/llamaswap").then((m) => ({ default: m.SwapWidget })));
export function Hero() {
  return <Flex
    position="relative"
    alignItems="center"
    justifyContent="center"
    overflow="hidden"
    id="hero-container"
    style={{ zIndex: 2 }}
  >
      {
    /* Swap Modal - zIndex: 2, centered by Flex */
  }
      <div style={{ position: "relative", zIndex: 2 }}>
        <Flex
    position="relative"
    width="100vw"
    height="100vh"
    pointerEvents="none"
    overflow="hidden"
    alignItems="center"
    justifyContent="center"
  >
          <Flex
    alignSelf="center"
    maxWidth="85vw"
    justifyContent="space-evenly"
    height="100%"
    pointerEvents="none"
    gap={12}
    $sm={{ pt: 28, pb: 58 }}
    $xs={{ pt: 40, pb: 100 }}
  >
            <RiseIn delay={0.4}>
              <Flex
    alignItems="center"
    justifyContent="center"
    flexDirection="column"
    mt={-48}
    $md={{ mt: -32 }}
    $sm={{ maxWidth: "unset", mt: 0 }}
    $xs={{ maxWidth: "unset", mt: 0, mb: 50 }}
  >
                <Text
    variant="heading1"
    fontFamily="Dm Sans"
    fontSize={84}
    lineHeight={90}
    textAlign="center"
    fontWeight="$book"
    justifyContent="flex-start"
    $md={{ fontSize: 62, lineHeight: 68 }}
    $sm={{ variant: "heading1", fontSize: 48, lineHeight: 54 }}
    $short={{ variant: "heading1", fontSize: 48, lineHeight: 54 }}
    pb={24}
  >
                  Deli Swap
                </Text>
                <Flex
    pointerEvents="auto"
    p="$padding8"
    width="1000px"
    backgroundColor="transparent"
    $sm={{ maxWidth: "380px" }}
    enterStyle={{ opacity: 0 }}
  >
                  <ErrorBoundary fallback={() => null}>
                    <Suspense fallback={null}>
                      <SwapWidgetLazy />
                    </Suspense>
                  </ErrorBoundary>
                </Flex>
                <RiseIn delay={0.5}>
                  <Text
    variant="body4"
    textAlign="center"
    maxWidth={430}
    color="$neutral2"
    width="100%"
    mt={8}
    $short={{ variant: "body2" }}
    $sm={{ maxWidth: "380px", width: "100%" }}
  >
                    Powered by swap.defillama.com
                  </Text>
                </RiseIn>
              </Flex>
            </RiseIn>
          </Flex>

          <Flex flex={1} />
        </Flex>
      </div>
    </Flex>;
}
